import type { FC } from 'react';
import React from 'react';
import cn from 'classnames';

import type { IWrapperProps } from './models';

export const Wrapper: FC<IWrapperProps> = ({
    children,
    className,
    id,
    isShadowEnabled,
    styles,
}) => (
    <div className={cn(styles.container, { [styles.shadow]: isShadowEnabled }, className)} id={id}>
        {children}
    </div>
);
